import React from 'react';
import ProfileImage from '../../ProfileImage';
import dayjs from 'dayjs';

const ModalFeedDetailFooter = ({ comments, reactions }: any) => {
    const likeCount = reactions ? reactions.length : 0;
    const commentCount = comments ? comments.length : 0;

    return (
        <div className="w-full px-[24px] pb-[32px]">
            {/* 좋아요/댓글 카운트 바 */}
            <div className="flex items-center gap-[20px] py-[12px] border-t border-[#E5E7EB] mt-[8px]">
                <span className="flex items-center gap-[4px] text-[13px] text-[#6B7280]">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round">
                        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78z" />
                    </svg>
                    좋아요 {likeCount}
                </span>
                <span className="flex items-center gap-[4px] text-[13px] text-[#6B7280]">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    댓글 {commentCount}
                </span>
            </div>

            {/* 댓글 목록 */}
            {comments && comments.length > 0 && (
                <div className="flex flex-col gap-[2px]">
                    {comments.map((item: any, index: number) => (
                        <div
                            key={index + 'detailComment'}
                            className="flex flex-col py-[12px] border-t border-[#F3F4F6]"
                        >
                            {/* 댓글 헤더 */}
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-[8px]">
                                    <ProfileImage
                                        imageUrl={item?.profileImageUrl}
                                        type="VerySmall"
                                        profileName={item?.profileName}
                                        profileColorType={item?.profileColorType}
                                        right={0}
                                    />
                                    <span className="text-[13px] font-semibold text-[#374151]">
                                        {item?.commenterName}
                                        <span className="text-[12px] font-normal text-[#9CA3AF] ml-[4px]">
                                            {item?.role === 'coach' ? '강사' : '회원'}
                                        </span>
                                    </span>
                                </div>
                                <span className="text-[11px] text-[#D1D5DB]">
                                    {dayjs(item?.createdTime).format('MM.DD HH:mm')}
                                </span>
                            </div>

                            {/* 댓글 내용 */}
                            <p className="text-[13px] text-[#4B5563] leading-[20px] mt-[6px] pl-[32px] whitespace-pre-wrap">
                                {item?.content}
                            </p>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ModalFeedDetailFooter;
